// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"_0d624b9a27--spinner--uXgOG","circle-spin":"_0d624b9a27--circle-spin--HhIQz"};